<script setup lang="ts">
import type { EditorState, LexicalEditor } from "lexical";
import { OnChangePlugin } from "lexical-vue";

const props = defineProps<{
  hasFocus: boolean;
}>();

const emit = defineEmits<{
  change: [editorState: EditorState, editor: LexicalEditor];
  unfocusedChange: [editorState: EditorState, editor: LexicalEditor];
}>();

function onChange(_event: Event): void;
function onChange(editorState: EditorState, editor: LexicalEditor, tags: Set<string>): void;
function onChange(editorState: EditorState | Event, editor?: LexicalEditor, tags?: Set<string>) {
  if (!editor) {
    return;
  }

  const lexicalEditorState = editorState as EditorState;
  emit("unfocusedChange", lexicalEditorState, editor);
  if (!props.hasFocus) {
    return;
  }

  if (tags?.has("collaboration")) {
    return;
  }

  emit("change", lexicalEditorState, editor);
}
</script>

<template>
  <OnChangePlugin ignore-selection-change @change="onChange" />
</template>
